export const views = {
  settingsMenu: 'settingsMenu',
  parentMembers: 'parentMembers',
  clinicAssignees: 'clinicAssignees',
  notificationSettings: 'notificationSettings',
};
